import "./cta.css"

const CtaSection = () => {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-wrapper">
          <div className="cta-content">
       <h2>Don’t Just Observe. Detect, Diagnose, Remediate, and Optimize with AgentSRE</h2>
            <p className="cta-desc">
            Join enterprises adopting Observability 3.0 with Agentic AI that cuts MTTR, prevents downtime, and optimizes cost
            </p>
            <div className="cta-btn">
              <a href="https://demo.elixirdata.co/">
                <p>Get Started Now</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
